import React, { useContext, useState, useCallback, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { AutomationRulesContext } from '../../context';
import { FormattedMessage, useIntl } from 'react-intl';
import { Input } from 'ui-components/components/input';
import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { useHasUnsupportedActions } from './unsupported-rule-banner';
import messages from './messages';
import style from './style.module.less';

const RuleName = () => {
  const {
    ruleName: contextRuleName,
    setRuleName: contextSetRuleName,
    setActive,
    selectedRule,
    hasAccess,
  } = useContext(AutomationRulesContext);
  const hasUnsupportedActions = useHasUnsupportedActions();
  const [ruleName, setRuleName] = useState(contextRuleName);

  // Sync local state when the context value changes externally (e.g., Shippy updates the name)
  useEffect(() => {
    setRuleName(contextRuleName);
  }, [contextRuleName]);

  const intl = useIntl();
  const onChange = useCallback(() => {
    setActive();
  }, [setActive]);

  const isActiveRuleDisabled = (!hasAccess && !selectedRule.isNew) || hasUnsupportedActions(selectedRule);
  const disabledTooltipMessage = hasUnsupportedActions(selectedRule)
    ? intl.formatMessage(messages.ruleActiveDisabledDueToUnsupportedActions || messages.ruleActiveDisabledTooltip)
    : intl.formatMessage(messages.ruleActiveDisabledTooltip);

  // @design-input-pending
  return (
    <div className={style['name-and-status']}>
      <div className={style['rule-name']}>
        <div>
          <FormattedMessage {...messages.ruleEditorName} />
        </div>
        <div>
          <Input maxLength={50} onBlur={contextSetRuleName} onChange={setRuleName} value={ruleName} />
        </div>
      </div>
      <div className={style['rule-active']}>
        <div>
          <FormattedMessage {...messages.ruleActiveCheckbox} />
        </div>
        <div>
          <CheckboxSlider
            checkboxId={selectedRule.isNew ? 'new-rule' : ruleName}
            checked={selectedRule.active}
            disabled={isActiveRuleDisabled}
            disabledTooltipMessage={disabledTooltipMessage}
            onChange={onChange}
          />
        </div>
      </div>
      <div>{selectedRule.isTemplate ? <FontAwesomeIcon className={style['template-icon']} icon={faInfoCircle} /> : null}</div>
    </div>
  );
};

export default RuleName;
